import { Header, Space, Text } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import { POPDFCustomFieldDisplayPresenter } from '@webapp/modules/purchasing/features/list-po-pdf-custom-field-display/presenters/POPDFCustomFieldDisplayPresenter'
import messages from './messages'
import { usePOPDFCustomFieldDisplayView } from './usePOPDFCustomFieldDisplayView'

/**
 * Feature Set: PO PDF custom fields section (PO PDF Custom Fields tab)
 *
 * Orchestrates:
 * - Heading + description (FS composition)
 * - The list feature's two toggle tables, bridged to the hook-only toggle
 *   command with an FS-owned optimistic flip + revert-on-failure
 *   (BHV-045/046)
 */
export const POPDFCustomFieldDisplayView = () => {
  const intl = useProcurifyIntl()

  const {
    states: { displayOverrides, isSaving },
    methods: { handleToggle },
  } = usePOPDFCustomFieldDisplayView()

  return (
    <Space>
      <Space size='small'>
        <Header as='h3'>{intl.formatMessage(messages.heading)}</Header>
        <Text>{intl.formatMessage(messages.description)}</Text>
      </Space>

      <POPDFCustomFieldDisplayPresenter
        onToggle={handleToggle}
        displayOverrides={displayOverrides}
        isSaving={isSaving}
      />
    </Space>
  )
}

POPDFCustomFieldDisplayView.displayName = 'POPDFCustomFieldDisplayView'
